import React, { useEffect, useState } from 'react'
// import { FaArrowsRotate } from 'react-icons/fa6'
import Countdown from 'react-countdown'
import { useSelector } from 'react-redux'

const ClockComponent = () => {
  const { currentLeague } = useSelector((state) => state.league)
  const { draftRounds, draftCounter, onTheClock } = useSelector((state) => state.draft)

  // const [currentTeam, setCurrentTeam] = useState(null)
  // console.log('🚀 ~ ClockComponent ~ draftCounter:', draftCounter)

  // useEffect(() => {
  //   if (draftRounds?.length > 0) {
  //     const isTeam = draftRounds.find(
  //       (v) => v?.round === draftCounter?.round && v?.position === draftCounter?.position,
  //     )
  //     if (isTeam) setCurrentTeam(isTeam)
  //   }
  // }, [draftRounds])

  const beforeRenderer = ({ days, hours, minutes, seconds, completed }) => {
    const d = String(days)
    const h = String(hours)
    const m = String(minutes).padStart(2, '0')
    const s = String(seconds).padStart(2, '0')

    const draftLiveMessage = currentLeague?.isDraftLive && (
      <>
        <h2 className='textLive'>Draft is Live!</h2>
        <br />
      </>
    )

    return (
      <>
        {draftLiveMessage}
        {completed ? (
          <p>00:00</p>
        ) : (
          <>
            {(d || h) && (
              <h2>
                Day: {d} Hour: {h}
              </h2>
            )}
            <br />
            <p>{`${m}:${s}`}</p>
          </>
        )}
      </>
    )
  }
  const afterRenderer = ({ minutes, seconds, completed }) => {
    const m = String(minutes).padStart(2, '0')
    const s = String(seconds).padStart(2, '0')

    const draftLiveMessage = currentLeague?.isDraftLive && (
      <>
        <h2 className='textLive'>Draft is Live!</h2>
        <br />
      </>
    )

    return (
      <>
        {draftLiveMessage}
        {completed ? <p>00:00</p> : <p>{`${m}:${s}`}</p>}
      </>
    )
  }

  const Timer = () => {
    return (
      <Countdown
        date={new Date(
          onTheClock && currentLeague?.isDraftLive ? draftCounter?.time : currentLeague?.draftStart,
        ).getTime()}
        renderer={onTheClock && currentLeague?.isDraftLive ? afterRenderer : beforeRenderer}
      />
    )
  }

  return (
    <div className='clock_box'>
      <div className='time_box'>
        <Timer />
      </div>
      {onTheClock && currentLeague?.isDraftLive && (
        <div className='clock_box_bottom'>
          <div className='cbb_right' style={{ backgroundImage: `url(${onTheClock?.team?.logo})` }}>
            {/* <FaArrowsRotate color='var(--primary)' size={30} /> */}
          </div>
          <div className='cbb_center'>
            <p>On The Clock</p>
            <p>{onTheClock?.team?.name}</p>
          </div>
          <div className='cbb_left'>
            {/* <p>#73</p> */}
            <p>#{draftRounds?.findIndex((v) => v?._id === onTheClock?._id) + 1}</p>
          </div>
        </div>
      )}
    </div>
  )
}

export default ClockComponent
